var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWallet03(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3359 15.5C15.3359 16.3284 16.0075 17 16.8359 17C17.6643 17 18.3359 16.3284 18.3359 15.5C18.3359 14.6716 17.6643 14 16.8359 14C16.0075 14 15.3359 14.6716 15.3359 15.5Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3397 8.30281C9.91213 7.92671 5.44064 7.12133 3.33594 6.5V15.5614C3.33594 17.5558 3.33594 18.553 3.95552 19.3663C4.5751 20.1796 5.42517 20.4093 7.12531 20.8687C9.87217 21.6109 12.7594 22.0529 15.3465 22.3057C18.0278 22.5677 19.3684 22.6987 20.3522 21.7997C21.3359 20.9007 21.3359 19.4566 21.3359 16.5682V14.5546C21.3359 11.7497 21.3359 10.3473 20.5288 9.47688C19.7218 8.60646 18.2611 8.50524 15.3397 8.30281Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9617 8.5C18.3394 7.07673 18.6812 4.48822 17.6629 3.20292C17.0175 2.38827 16.0582 2.46654 15.1177 2.54926C10.1738 2.98406 6.68138 3.86731 4.72895 4.46737C3.88942 4.7254 3.33594 5.54522 3.33594 6.46044",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet03);
export default __webpack_public_path__ + "static/media/wallet-03.93baae9472a0359e2f0058ef8635ffbb.svg";
export { ForwardRef as ReactComponent };